import React from "react";

// =====================================================================
// Shared club avatar — Redesign 2.0 artboard recipe §1.2/§1.8: pastel
// disc + deep tone text, 700 weight, deterministic per club name; the
// club logo image wins when present. Sizing/typography come from the
// caller via className (the boards use different scales per surface).
//
// Promoted VERBATIM from the B4 local shim in
// `src/pages/club-network/AgentSearchInbox.js` (D-B4-3 unification —
// B1's shared layer shipped no avatar recipe). common/Avatar.js is NOT
// a substitute: saturated bg + white text, inline-style pixel sizing —
// no true visual match to the artboard.
// =====================================================================

const AVATAR_PAIRS = [
  ["#E8F1FF", "#1B6FE0"], // blue
  ["#E0F2FE", "#0369A1"], // sky
  ["#FEF3C7", "#B45309"], // amber
  ["#EDE9FE", "#6D28D9"], // violet
  ["#FCE7F3", "#BE185D"], // pink
  ["#DCFCE7", "#15803D"], // green
  ["#FFE4E6", "#BE123C"], // red-rose
];
const avatarPair = (seed) => {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_PAIRS[Math.abs(hash) % AVATAR_PAIRS.length];
};
const clubInitials = (name) =>
  (name || "?")
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

const ClubAvatar = ({ club, className = "" }) => {
  if (club?.logo) {
    return (
      <img
        src={club.logo}
        alt={club.name}
        className={`flex-none rounded-full object-cover ${className}`}
      />
    );
  }
  const [bg, fg] = avatarPair(club?.name || "?");
  return (
    <span
      className={`flex-none rounded-full inline-flex items-center justify-center font-bold ${className}`}
      style={{ backgroundColor: bg, color: fg }}
      aria-hidden="true"
    >
      {clubInitials(club?.name)}
    </span>
  );
};

export default ClubAvatar;
